import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputWrite } from '@/pcomponents/common/date_picker/custom_input';
import TodoDailyCDataFunc from "@/pcomponents/common/content/todo/todo_dailyc/data";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";

function WriteArea(props: any) {
  let myProps = {
    todo_dailyc_data: {},
    set_todo_dailyc_data: (inData: any) => { },
    memo_input_ref: null,
    ...props
  };
  let todo_dailyc_data = myProps.todo_dailyc_data;
  let select_subject_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });
  const memo_input_ref = myProps.memo_input_ref;
  const onChangeInput = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_row_data = { ...todo_dailyc_data };
    change_row_data[name] = value;
    myProps.set_todo_dailyc_data(change_row_data);
  };

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    myProps.set_todo_dailyc_data({
      ...todo_dailyc_data,
      ...{ [key]: date_str }
    });
  };

  return (
    <div className="write_table_small">
      <table>
        <colgroup>
          <col width={"20%"}></col>
          <col width={"30%"}></col>
          <col width={"20%"}></col>
          <col width={"30%"}></col>
        </colgroup>
        <tbody>
          <tr>
            <th>날짜</th>
            <td>
              <div style={{ display: "inline-block", width: 100 }}>
                <DatePicker
                  selected={todo_dailyc_data.a_date != "" ? new Date(todo_dailyc_data.a_date) : null}
                  onChange={(date: Date) => {
                    onChangeDatePicker("a_date", date);
                  }}
                  locale={ko}
                  dateFormat="yyyy-MM-dd"
                  customInput={<CustomInputWrite />}
                  renderCustomHeader={customHeaderFunc}
                />
              </div>
            </td>
            <td colSpan={2}>
              과목:
              <input type="text" className="row-input ml-1" name="a_subject" value={todo_dailyc_data.a_subject}
                style={{ width: 70 }} onChange={onChangeInput} />
              <select className="ml-1 row-input border" value={todo_dailyc_data.a_subject}
                onChange={(e: any) => {
                  onChangeInput({
                    target: {
                      name: "a_subject",
                      value: e.target.value
                    }
                  });
                }} style={{ width: 70 }}>
                <option value="">선택없음</option>
                {
                  select_subject_option_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.value}>
                        {item.text}
                      </option>
                    );
                  })
                }
              </select>
            </td>
          </tr>
          <tr>
            <th>구분</th>
            <td colSpan={3}>
              <SelectBoxBar
                valueTextArr={TodoDailyCDataFunc.sort_select_arr}
                value={todo_dailyc_data.a_sort}
                name="a_sort"
                on_change={(inData: any) => {
                  onChangeInput({
                    target: {
                      name: inData.name,
                      value: inData.value
                    }
                  });
                }}
              ></SelectBoxBar>
            </td>
          </tr>
          <tr>
            <th>Star</th>
            <td colSpan={3}>
              <label>
                <input type="checkbox" name="a_teacher_star" value="" checked={todo_dailyc_data.a_teacher_star == 1}
                  onChange={(e: any) => {
                    let value = e.target.checked ? 1 : 0;
                    onChangeInput({
                      target: {
                        name: "a_teacher_star",
                        value: value
                      }
                    });
                  }} />
                <span className="ml-1">
                  별주기
                  <img src={process.env.REACT_APP_API_URL + "/img/comp/plan/star_yellow50.png"}
                    style={{ height: "18px", marginLeft: "3px" }} />
                </span>
              </label>
              <span className="ml-2">
                <label>
                  <input type="checkbox" name="a_teacher_star" value="" checked={todo_dailyc_data.a_teacher_star == 2}
                    onChange={(e: any) => {
                      let value = e.target.checked ? 2 : 0;
                      onChangeInput({
                        target: {
                          name: "a_teacher_star",
                          value: value
                        }
                      });
                    }} />
                  <span className="ml-1">
                    별주기
                    <img src={process.env.REACT_APP_API_URL + "/img/comp/plan/star_yellow50.png"}
                      style={{ height: "18px", marginLeft: "3px" }} />
                    <img src={process.env.REACT_APP_API_URL + "/img/comp/plan/star_yellow50.png"}
                      style={{ height: "18px", marginLeft: "3px" }} />
                  </span>
                </label>
              </span>
            </td>
          </tr>
          <tr>
            <th>메모</th>
            <td colSpan={3}>
              <TextAreaComponent
                name="a_memo"
                value={todo_dailyc_data.a_memo}
                onChange={onChangeInput}
                style={{ minHeight: "45px" }}
                input_ref={memo_input_ref}
              ></TextAreaComponent>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default WriteArea;